import { Button } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid-premium";
import { useState } from "react";
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { MultiEditPopup } from "./MultiLineEdit";



export function CustomToolbar(tableSettings) {
    return (
        <GridToolbarContainer>
            {/* <GridToolbarQuickFilter></GridToolbarQuickFilter> */}
            {/* <GridToolbarColumnsButton /> */}
            {/* <GridToolbarFilterButton /> */}
            {/* <GridToolbarDensitySelector /> */}
            {/* {tableSettings?.checkboxSelection ?
                <MultiEditButton tableSettings={tableSettings}></MultiEditButton>
                : null} */}

            {/* <Button
                disabled={!tableSettings?.hasUnsavedRows || tableSettings?.isSaving}
                onClick={() => {
                    tableSettings?.discardChanges()
                }}
                startIcon={<RestoreIcon />}
            >
                Discard changes
            </Button> */}
            {/* <GridToolbarExport /> */}
        </GridToolbarContainer>
    );
}

const MultiEditButton = ({ tableSettings }) => {
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => { setOpen(true); };
    const handleClose = () => { setOpen(false); };
    return (
        <>
            <Button
                disabled={!tableSettings?.rowSelectionModel?.length}
                onClick={handleClickOpen}
                startIcon={<AppRegistrationIcon />}
            >
                Edit Multiple Rows
            </Button>
            <MultiEditPopup

                open={open}
                onClose={handleClose}
                tableSettings={tableSettings}
            />
        </>
    );
};

